import { Link } from 'react-router-dom';
import './Installation.css';

export default function VaultPlaceholder() {
  return (
    <div className="installation-page" data-testid="vault-placeholder-page">
      <div className="installation-grain" aria-hidden="true" />

      <header className="installation-header">
        <div className="installation-brand" data-testid="vault-brand-logo">
          <img src="/zato-mask.png" alt="" className="installation-brand-icon" />
          <span>ZATO</span>
        </div>
      </header>

      <main className="installation-center">
        <p className="installation-tagline" data-testid="vault-placeholder-label">
          // PHASE 2 // UNDER CONSTRUCTION
        </p>
        <Link to="/" className="installation-footer-legacy" data-testid="vault-back-link">
          ← RETURN
        </Link>
      </main>

      <footer className="installation-footer">
        <span className="installation-footer-label">VAULT // GATEWAY</span>
      </footer>
    </div>
  );
}
